import { Box, CircularProgress } from "@material-ui/core";
import StreamflowChart from "./StreamflowChart";
import useStreamflowSeries from "../../../hooks/charts/useStreamflowSeries";

export default function StreamflowChartContainer({
  parameterid,
  locationid,
  startDate,
  endDate,
  height = 400,
}) {
  const { seriesByLoc, unit, parameter, isLoading, isError } =
    useStreamflowSeries({
      parameterid,
      locationid,
      startDate,
      endDate,
    });

  if (isLoading) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !Object.keys(seriesByLoc).length) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        No data
      </Box>
    );
  }

  return (
    <StreamflowChart
      seriesByLoc={seriesByLoc}
      unit={unit}
      parameter={parameter}
      height={height}
    />
  );
}
